export default "__VITE_ASSET__HHXTV7V4__"